<template lang="html">
    <div class="container-fluid p-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        Deposit List
                    </div>
                    <div class="card-body">
                         <div class="row">
                            <div class="col-md-12">
                                <div class="row search-form">
                                    <div class="col-md-3 mt-1">
                                        <input type="text" v-model="filter.name" class="form-control" placeholder="Name">
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <input type="text" v-model="filter.phone" class="form-control" placeholder="Phone">
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <b-form-datepicker
                                            v-model="filter.from"
                                            locale="en-CA"
                                            :value-as-date="false"
                                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                            class="w-100"
                                            :today-button="true"
                                            :reset-button="true"
                                            :close-button="true"
                                            label-today-button="Today"
                                            label-reset-button="Clear"
                                            label-close-button="Close"
                                            placeholder="YYYY-MM-DD"
                                        />
                                    </div>
                                     <div class="col-md-3 mt-1">
                                        <b-form-datepicker
                                            v-model="filter.to"
                                            locale="en-CA"
                                            :value-as-date="false"
                                            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                            class="w-100"
                                            :today-button="true"
                                            :reset-button="true"
                                            :close-button="true"
                                            label-today-button="Today"
                                            label-reset-button="Clear"
                                            label-close-button="Close"
                                            placeholder="YYYY-MM-DD"
                                        />
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <input type="text" v-model="filter.email" class="form-control" placeholder="Email">
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <select v-model="filter.payment_method_id" class="form-control">
                                            <option value="">Select Payment Method</option>
                                            <option v-for="bank in paymentMethod" :key="bank.id" :value="bank.id">{{ bank.name }}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <select v-model="filter.status" class="form-control">
                                            <option value="">Select Status</option>
                                            <option value="pending">Pending</option>
                                            <option value="completed">Completed</option>
                                            <option value="failed">Failed</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <button class="btn btn-primary mr-1 fbutton" @click="search()"><i class="fas fa-search"></i> Search</button>
                                        <button class="btn btn-info fbutton" @click="reset()"><i class="fas fa-sync"></i> Refresh</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mt-4">
                            <table class="common-table">
                                <thead>
                                    <tr>
                                        <th>Actions</th>
                                        <th v-for="(value, key) in columns" :key="key" @click="sortBy(key)" style="cursor:pointer">
                                            {{ value }}
                                            <span v-if="filter.sortKey === key">
                                                <i v-if="filter.orderBy === 'asc'" class="fas fa-sort-up"></i>
                                                <i v-else class="fas fa-sort-down"></i>
                                            </span>
                                        </th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, index) in dataList" :key="data.id">
                                        <td>
                                            <button v-if="data.status == 'pending'" v-b-modal.bv-modal-approve class="btn btn-action btn-approve " @click="editData(data)">Approve</button>
                                            <button v-if="data.status == 'pending'" v-b-modal.bv-modal-reject class="btn btn-action btn-reject " @click="editData(data)">Reject</button>
                                            <span v-if="data.status == 'completed'" class="badge badge-success">Completed</span>
                                            <span v-if="data.status == 'failed'" class="badge badge-danger">Failed</span>
                                        </td>
                                        <td>{{ data.last_six_digit }}</td>
                                        <td>{{ data.payment_name }}</td>
                                        <td>{{ data.wallet_name }}</td>
                                        <td>{{ data.wallet_account_number }}</td>
                                        <td>{{ data.amount }}</td>
                                        <td>{{ data.master_name }}</td>
                                        <td>{{ data.user_name }}</td>
                                        <td>{{ data.user_phone_or_email }}</td>
                                        <td>{{ data.transaction_date }}</td>
                                    </tr>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="Object.keys(columns).length + 1" class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="table-pagination-minimal">
                                <div class="table-pagination-row">
                                    <div v-if="dataList.length > 0 " class="table-info-minimal left-align">
                                        Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                                    </div>
                                    <nav class="pagination-minimal">
                                        <ul>
                                            <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                                <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                                    <i class="fas fa-angle-left"></i>
                                                </button>
                                            </li>
                                            <li v-for="page in metaData.last_page" :key="page"
                                                :class="{ 'active':metaData.current_page === page }"
                                                v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                                <button @click.prevent="next(page)">{{ page }}</button>
                                            </li>
                                            <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                                <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                                    <i class="fas fa-angle-right"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <b-modal id="bv-modal-status" ref="my-modal" title="Change Status" hide-footer>
                            <div class="form-group">
                                <label for="inputUserName">User Name</label>
                                <input type="text" v-model="userName" id="inputUserName" class="form-control" disabled>
                            </div>
                            <div class="form-group">
                                <label for="status">Select Status</label>
                                <select v-model="status" id="status" class="form-control">
                                    <option value="pending">Pending</option>
                                    <option value="completed">Completed</option>
                                    <option value="failed">Failed</option>
                                </select>
                            </div>
                            <b-button class="mt-3 btn-success" block @click="editStatus()">Submit</b-button>
                        </b-modal>
                        <b-modal id="bv-modal-delete" ref="my-modal" title="Delete" hide-footer>
                            <p class="my-4">Are you sure to delete ? </p>
                            <p class="my-4 text-danger">{{alert}}</p>
                            <b-button class="mt-3 btn-danger" block @click="deleteItem()">Delete</b-button>
                        </b-modal>
                        <b-modal id="bv-modal-approve" ref="my-modal" title="Approve" hide-footer>
                            <p class="my-4">Are you sure to approve ? </p>
                            <p class="my-4 text-danger">{{alert}}</p>
                            <b-button class="mt-3 btn-success" block @click="approveChange()">Approve</b-button>
                        </b-modal>
                        <b-modal id="bv-modal-reject" ref="my-modal" title="Reject" hide-footer>
                            <p class="my-4">Are you sure to reject ? </p>
                            <p class="my-4 text-danger">{{alert}}</p>
                            <b-button class="mt-3 btn-danger" block @click="rejectChange()">Reject</b-button>
                        </b-modal>
                        <router-link class="float" to="deposit-create">
                            <i class="fa fa-plus my-float" style="padding: 37%;"></i>
                        </router-link>
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import { BFormDatepicker } from 'bootstrap-vue'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: 'depositList',
        metaInfo: {
            title: "Deposit List",
            titleTemplate: "%s ← BXB",
        },
        components: {
            Loading,
            BFormDatepicker
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                alert: "",
                id: '',
                userName: '',
                status: '',
                dataList: [],
                paymentMethod: [],
                permissions: '',
                columns: {
                    last_six_digit: 'Six Digit',
                    payment_name: "Payment",
                    wallet_name: "Wallet",
                    wallet_account_number: "Account Number",
                    amount: "Amount",
                    master_name: "Master",
                    user_name: "Name",
                    user_phone_or_email: "Contact",
                },
                filter: {
                    page: 1,
                    orderBy: "asc",
                    sortKey: "created_at",
                    limit: 10,
                    name: '',
                    phone: '',
                    email: '',
                    status: '',
                    payment_method_id: '',
                    from: '',
                    to: ''
                },
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                }
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
        computed: {},
        methods: {
            ...mapActions({
                depositListAction: 'depositListAction',
                depositDeleteAction: 'depositDeleteAction',
                paymentMethodAction: 'paymentMethodAction',
                depositStatusCompletedAction: 'depositStatusCompletedAction',
                depositStatusFailedAction: 'depositStatusFailedAction'

            }),
            sortBy(column) {
                this.filter.sortKey = column
                if (this.filter.sortKey == column) {
                    if (this.filter.orderBy == "asc") {
                        this.filter.orderBy = "desc"
                    } else if (this.filter.orderBy == "desc") {
                        this.filter.orderBy = "asc"
                    }
                } else {
                    this.filter.orderBy = "asc"
                }
                this.fetchData()
            },
            async getPaymentMethod(){
				await this.paymentMethodAction().then(res => {
					this.paymentMethod = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
            async search() {
                this.filter.page = 1
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async fetchData() {
                this.isLoading = true
                let option = this.filter
                await this.depositListAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data.data
                        this.metaData.last_page = res.data.meta.lastPage
                        this.metaData.current_page = res.data.meta.currentPage
                        this.metaData.prev_page_url = res.data.meta.prevPageUrl
                        this.metaData.from = res.data.meta.from
                        this.metaData.to = res.data.meta.to
                        this.metaData.total = res.data.meta.total
                        this.$router.replace({ 
                            path: 'deposit-list', 
                            query: { 
                                page: this.filter.page, 
                                orderBy: this.filter.orderBy, 
                                sortKey: this.filter.sortKey,
                                name: this.filter.name,
                                phone: this.filter.phone,
                                email: this.filter.email,
                                status: this.filter.status,
                                payment_method_id: this.filter.payment_method_id,
                                from: this.filter.from,
                                to: this.filter.to
                            } 
                        }).catch(()=>{})
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            reset(){
                this.$router.replace({ 
                    path: 'deposit-list', 
                    query: {
                        page: 1, 
                        orderBy: 'desc', 
                        sortKey: 'created_at'
                    } 
                }).catch(()=>{})
                this.$router.go()
            },
            editData(data) {
                this.id = data.id
                this.userName = data.user_name
                this.status = data.status
            },
            async approveChange(){
                this.isLoading = true
				let option = {
					id: this.id,
					status: 'completed'
				}
                console.log(this.status)
                await this.depositStatusCompletedAction({
                    ...option
                }).then(res => {
                    if(res.success == false){
                        this.alert = res.message
                    }else{
                        this.id = "",
                        this.status = "",
                        this.userName = "",
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
                }).catch(err => this.isLoading = true)
            },
            async rejectChange(){
                this.isLoading = true
				let option = {
					id: this.id,
					status: 'failed'
				}
                console.log(this.status)
                await this.depositStatusFailedAction({
                    ...option
                }).then(res => {
                    if(res.success == false){
                        this.alert = res.message
                    }else{
                        this.id = "",
                        this.status = "",
                        this.userName = "",
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
                }).catch(err => this.isLoading = true)
            },
            deleteData(data){
                this.id = data.id
                this.alert = ""
            },
            async deleteItem() {
				this.isLoading = true
				let option = {
					id: this.id,
				}
				await this.depositDeleteAction({
					...option
				}).then(res => {
					if(res.status == 'fail'){
                        this.alert = res.message
                    }else{
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            }

        },
        async mounted() {
            let user = JSON.parse(window.localStorage.getItem('user'))
            this.permissions = user.permissions
            this.filter.page = this.$route.query.page
            this.filter.orderBy = this.$route.query.orderBy
            this.filter.sortKey = this.$route.query.sortKey
            this.filter.name = this.$route.query.name || ''
            this.filter.phone = this.$route.query.phone || ''
            this.filter.email = this.$route.query.email || ''
            this.filter.status = this.$route.query.status || ''
            this.filter.payment_method_id = this.$route.query.payment_method_id || ''
            this.filter.from = this.$route.query.from || ''
            this.filter.to = this.$route.query.to || ''
            await this.fetchData()
            await this.getPaymentMethod()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
.badge-16 {
font-size: 16px;
}
.btn-approve {
    background-color: green;
    color: #ffffff;
}
.btn-reject {
    background-color: red;
    color: #ffffff;
}
</style>